module.exports = __webpack_public_path__ + "img/H1.cc0655d7.png";